// extracted by mini-css-extract-plugin
export default {"component":"BonusCard__component--lc-YtNqr","link":"BonusCard__link--lc-dwpaA","content":"BonusCard__content--lc-lsQoS"};